import { connect } from 'react-redux';

import Items from './Items';
import { addItem, deleteItem, editItem, getItemsList } from './itemsActions';

const mapStateToProps = state => ({
  itemsList: state.items.itemsList,
  isLoading: state.items.isLoading,
  isCrudLoading: state.items.isCrudLoading,
});

const mapDispatchToProps = dispatch => ({
  getItemsList: () => dispatch(getItemsList()),
  addItem: item => dispatch(addItem(item)),
  editItem: item => dispatch(editItem(item)),
  deleteItem: id => dispatch(deleteItem(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Items);
